<template>
  <kinesis-container class="cover">
    <kinesis-element
      type="depth"
      class="circle darkgreenposition"
      :strength="-20"
    >
      <div
        class="smooth darkgreencolor"
        :style="`transform:scale(${amplitude[2] / 350 + 1})`"
      ></div>
    </kinesis-element>
    <kinesis-element
      type="depth"
      class="circle yellowgreenposition"
      :strength="-10"
    >
      <div
        class="smooth yellowgreencolor"
        :style="`transform:scale(${amplitude[0] / 350 + 1})`"
      ></div>
    </kinesis-element>

    <kinesis-element type="depth" class="cover-container" :strength="20">
      <div
        class="smooth img"
        :style="`transform:scale(${amplitude[1] / 350 + 1})`"
      >
        <img
          class="jacket fake"
          :src="interloper"
          alt="Carbon Based Lifeforms - Cover"
        />
        <img
          class="jacket cover-cbl"
          :src="interloper"
          alt="Carbon Based Lifeforms - Cover"
        />
        <img
          class="jacket cover-buckethead"
          :src="racks"
          alt="Buckethead - Sunbursts"
        />
        <img
          class="jacket cover-matteis"
          :src="baroque"
          alt="Matteis - Diverse Bizzarrie"
        />
      </div>
    </kinesis-element>
    <kinesis-element
      type="depth"
      class="circle brightgreenposition"
      :strength="25"
    >
      <div
        class="smooth brightgreencolor"
        :style="`transform:scale(${amplitude[3] / 350 + 1})`"
      ></div>
    </kinesis-element>
  </kinesis-container>
</template>

<script>
import { KinesisContainer } from "vue-kinesis";
import { KinesisElement } from "vue-kinesis";
import interloper from "@/assets/interloper.jpg";
import racks from "@/assets/racks.jpg";
import baroque from "@/assets/baroque.jpg";
// eslint-disable-next-line no-unused-vars
import anime from "animejs";
export default {
  components: {
    KinesisContainer,
    KinesisElement
  },
  data() {
    return {
      racks,
      interloper,
      baroque
    };
  },
  props: {
    amplitude: [Array, Number],
    artist: String
  },
  watch: {
    artist(newVal, oldVal) {
      anime({
        targets: `.cover-${newVal}`,
        translateY: [50, 0],
        opacity: [0, 1],
        easing: "easeInOutQuint"
      });
      anime({
        targets: `.cover-${oldVal}`,
        translateY: -50,
        opacity: 0,
        easing: "easeInOutQuint"
      });
    }
  },
  methods: {
    enter(e) {
      anime({
        targets: e,
        translateY: [50, 0],
        opacity: [0, 1],
        delay: 1000,
        easing: "easeInOutQuint"
      });
    },
    leave(e) {
      anime({
        targets: e,
        translateY: -50,
        opacity: 0,
        delay: 1000,
        easing: "easeInOutQuint"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.musics {
  display: flex;
  height: 60vh;
  color: white;

  > div:nth-of-type(1) {
    width: 40%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div:nth-of-type(2) {
    width: 60%;
    padding-left: 25px;
  }

  .img {
    width: 70%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: inline-block;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .fake {
      position: relative;
      opacity: 0;
      display: inline-block;
      width: 100%;
    }
  }

  h3 {
    font-size: 40px;
    align-self: flex-start;
  }
}

.cover {
  position: relative;
}

.jacket {
  opacity: 0;
}

.cover-cbl {
  opacity: 1;
}

.cover-container {
  text-align: center;
}

.music {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.smooth {
  transition: transform 100ms;
}

.play {
  background-color: #edd88c;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

#waveform {
  width: 80%;
}

.player {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.circle {
  border-radius: 100%;
  position: absolute;

  &.yellowgreenposition {
    top: 40px;
    left: 15px;
  }

  .yellowgreencolor {
    background-color: $color-yellowgreen;
    width: 90px;
    height: 90px;
    border-radius: 100%;
  }

  &.darkgreenposition {
    top: 55px;
    left: 20px;
  }

  .darkgreencolor {
    background-color: $color-darkgreen;
    width: 170px;
    height: 170px;
    border-radius: 100%;
  }

  &.brightgreenposition {
    bottom: 50px;
    right: 20px;
  }

  .brightgreencolor {
    border: $color-brightgreen 4px solid;
    border-radius: 100%;
    width: 80px;
    height: 80px;
  }
}
</style>
